/**
 * Dashboard widgets — wired into `config.dashboard`.
 *
 * A single static intro widget. NSW RLGSP has no summary data, so there is no
 * `subtitle` — the shared Dashboard shell renders the welcome heading only.
 */

import type { WidgetConfig } from '#lib/apps/types.js';
import IntroWidget from '#lib/components/dashboard/IntroWidget.svelte';

export const widgets: WidgetConfig[] = [
	{
		id: 'summary',
		component: IntroWidget,
		props: { text: 'Transport for New South Wales Regional Local Government Speed Program.' }
	}
];
